import { render } from "./CloningNode.vue?vue&type=template&id=1b56224c"
import script from "./CloningNode.vue?vue&type=script&lang=js"
export * from "./CloningNode.vue?vue&type=script&lang=js"

import "./CloningNode.vue?vue&type=style&index=0&id=1b56224c&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__